export const technicalSkills = [
  { name: "Test Automation", level: 90 },
  { name: "Appium", level: 85 },
  { name: "Selenium", level: 80 },
  { name: "Playwright", level: 75 },
  { name: "Java", level: 80 },
  { name: "JavaScript", level: 75 },
  { name: "Git", level: 85 },
  { name: "CI/CD", level: 80 },
  { name: "Agile Methodologies", level: 90 },
  { name: "Test Planning", level: 85 },
  { name: "Defect Tracking", level: 90 },
  { name: "API Testing", level: 80 },
];

export const softSkills = [
  "Analytical and Logical Thinking",
  "Troubleshooting",
  "Communication",
  "Shift Left Testing",
  "Attention to Details",
  "Time Management",
];

export const tools = [
  "Appium",
  "Selenium",
  "Playwright",
  "Java",
  "JavaScript",
  "Git",
  "GitHub Actions",
  "Jenkins",
  "AWS",
  "Jira",
  "Postman",
];
